import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Button, Spin, Icon, message } from 'antd';
import styled from 'styled-components';
import Router from 'next/router';
import CommonPageContainer from '../common/CommonPageContainer';
import SubmitIssueForm from './SubmitIssueForm';
import withSubmitIssue from '../../graphql/hocs/slack/withSubmitIssue';

const SubmitIssueWrapper = styled(Row)`
  display: flex;
  min-height: calc(100vh - 80px);
  align-items: center;
  justify-content: center;
  padding: 1rem;

  .sumbit-issue-card {
    background-color: #fff;
    padding: 1rem;
  }

  .result {
    min-height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 1rem;

    @media (min-width: 768px) {
      min-height: 500px;
    }
  }

  .result__spinner {
    font-size: 3rem;
    margin-bottom 1rem;
  }

  .result__header {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .result__body {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  .result__btn {
    padding: 0 3rem;
  }
`;

@withSubmitIssue
class SubmitIssue extends Component {
  static propTypes = {
    onSubmitIssue: PropTypes.func.isRequired,
  };

  state = {
    submitted: false,
    isLoading: false,
    initialValues: {
      name: '',
      description: '',
    },
  };

  handleSubmitForm = values => {
    this.setState({ isLoading: true });

    this.sendIssue(values);
  };

  sendIssue = async values => {
    const { onSubmitIssue } = this.props;

    const result = await onSubmitIssue({ variables: values });

    if (result.data.sendIssueTicket) {
      this.setState({
        submitted: true,
        isLoading: false,
        initialValues: { name: '', description: '' },
      });
    } else {
      message.error('Sorry. Failed to send your issue ticket. Please try again.');
      this.setState({ isLoading: false, initialValues: values });
    }
  };

  handleClickBack = () => {
    Router.back();
  };

  renderContent = () => {
    const { submitted, isLoading, initialValues } = this.state;
    const antIcon = <Icon type="loading" className="result__spinner" spin />;

    let content = (
      <div className="result">
        <Spin indicator={antIcon} />
        <div className="result__body">Sending issue ticket</div>
      </div>
    );

    if (!submitted && !isLoading) {
      content = <SubmitIssueForm onSubmit={this.handleSubmitForm} initialValues={initialValues} />;
    }

    if (submitted && !isLoading) {
      content = (
        <div className="result">
          <div className="result__header">Thank you!</div>
          <div className="result__body">
            We have received your message and we&apos;ll working on it as soon as possible.
          </div>
          <Button className="result__btn" type="primary" onClick={this.handleClickBack}>
            Go Back
          </Button>
        </div>
      );
    }

    return content;
  };

  render() {
    const { submitted, isLoading } = this.state;

    return (
      <CommonPageContainer pageTitle="Submit an Issue">
        <SubmitIssueWrapper>
          <Col xs={24} md={16} xl={12}>
            <Card title={!submitted && !isLoading ? 'Submit an Issue' : ''}>
              {this.renderContent()}
            </Card>
          </Col>
        </SubmitIssueWrapper>
      </CommonPageContainer>
    );
  }
}

export default SubmitIssue;
